import { useVoipRoomStore } from '@stores/voip-room'
import { useLessonRoomStore } from '@stores/lesson-room'

import { trackEvent } from '@tools/amplitude'

export const trackClassroomEvent = (eventName: string, eventProps?: Record<string, any>): void => {
  const voipRoomStore = useVoipRoomStore()
  const lessonRoomStore = useLessonRoomStore()
  const booking = lessonRoomStore.getBooking

  trackEvent(eventName, {
    event_type: 'classroom',
    provider: voipRoomStore.getRoomData?.provider ?? null,
    booking_id: booking?.id ?? null,
    room_type: booking?.room_data?.type ?? null,
    ...eventProps,
  })
}
